var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndroidtv = function SvgAndroidtv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 14.25C9.24632 14.25 9.75 13.7463 9.75 13.125C9.75 12.5037 9.24632 12 8.625 12C8.00368 12 7.5 12.5037 7.5 13.125C7.5 13.7463 8.00368 14.25 8.625 14.25Z",
    fill: "#3DDB85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 14.25C15.9963 14.25 16.5 13.7463 16.5 13.125C16.5 12.5037 15.9963 12 15.375 12C14.7537 12 14.25 12.5037 14.25 13.125C14.25 13.7463 14.7537 14.25 15.375 14.25Z",
    fill: "#3DDB85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3C1.725 3 0.75 3.975 0.75 5.25V17.25C0.75 18.525 1.725 19.5 3 19.5H7.5V22.5H16.5V19.5H21C22.275 19.5 23.25 18.525 23.25 17.25V5.25C23.25 3.975 22.275 3 21 3ZM3 16.5C3.45 13.8 5.175 11.475 7.5 10.2L6.075 7.875C5.925 7.5 6 7.05 6.375 6.825C6.75 6.675 7.2 6.75 7.425 7.125L8.85 9.525C9.825 9.225 10.875 9 12 9C13.125 9 14.175 9.225 15.15 9.525L16.575 7.125C16.8 6.75 17.25 6.675 17.625 6.825C18 7.05 18.075 7.5 17.925 7.875L16.5 10.2C18.825 11.55 20.55 13.8 21 16.5H3Z",
    fill: "#3DDB85"
  })));
};
export default SvgAndroidtv;